import React, { memo, useCallback } from 'react'

import { TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { useSearchPageStore } from 'Pods/SearchPage/Store'
import { setMinPrice, setMaxPrice } from 'Pods/SearchPage/Store/actions/pricing'
import { DEFAULT_STATE } from 'Pods/SearchPage/Store/constants'

function PriceInputs() {
  const minPrice = useSearchPageStore(state => state.minPrice)
  const maxPrice = useSearchPageStore(state => state.maxPrice)

  const handleMinPriceChange = useCallback((e) => {
    const value = e.target.value
    if (value === '') {
      setMinPrice(value)

      return
    }

    const numValue = parseInt(value, 10)
    if (!Number.isNaN(numValue) && numValue >= 0) {
      setMinPrice(numValue)
    }
  }, [])

  const handleMaxPriceChange = useCallback((e) => {
    const value = e.target.value
    if (value === '') {
      setMaxPrice(value)

      return
    }

    const numValue = parseInt(value, 10)
    if (!Number.isNaN(numValue) && numValue >= 0) {
      setMaxPrice(numValue)
    }
  }, [])

  const handleMinPriceBlur = useCallback(() => {
    if (minPrice !== '' && maxPrice !== '' && minPrice > maxPrice) {
      setMaxPrice(DEFAULT_STATE.maxPrice)
    }
  }, [minPrice, maxPrice])

  const handleMaxPriceBlur = useCallback(() => {
    if (minPrice !== '' && maxPrice !== '' && maxPrice < minPrice) {
      setMinPrice(DEFAULT_STATE.minPrice)
    }
  }, [minPrice, maxPrice])

  return (
    <div className="price-filter__price-inputs">
      <TextInput
        id="min-price"
        label="Min Price"
        inputType="number"
        size="tiny"
        type="primary"
        value={minPrice}
        onChange={handleMinPriceChange}
        onBlur={handleMinPriceBlur}
        placeholder="0"
        step="1"
        isCurrency
        isPilot
        wrapperClassName="price-filter__price-input"
      />
      <TextInput
        id="max-price"
        label="Max Price"
        inputType="number"
        size="tiny"
        type="primary"
        value={maxPrice}
        onChange={handleMaxPriceChange}
        onBlur={handleMaxPriceBlur}
        placeholder="0"
        step="1"
        isCurrency
        isPilot
        wrapperClassName="price-filter__price-input"
      />
    </div>
  )
}

export default memo(PriceInputs)
